import React from 'react'
 import HeroImg from "../images/tuwe2.png"

const HeroSection = () => {
  return (
    <>
         {/* Hero Section */}
<section id="hero" className="hero section dark-background">
  <img
    src={HeroImg}
    alt=""
    data-aos="fade-in"
  />

  <div className="container d-flex flex-column align-items-center">
    <h2 data-aos="fade-up" data-aos-delay="100">
      Together we believe
    </h2>
    <br />
    <h2 data-aos="fade-up" data-aos-delay="100">
      Together we achieve
    </h2>

    {/*
    <p data-aos="fade-up" data-aos-delay="200">
      We are team of talented designers making websites with Bootstrap
    </p>
    */}

    <div
      className="d-flex mt-4"
      data-aos="fade-up"
      data-aos-delay="300"
    >
      <a href="#about-us" className="btn-get-started">
        Who We Are
      </a>
    </div>
  </div>
</section>
{/* /Hero Section */}
    </>
  )
}

export default HeroSection